import { IStore } from '../../index'

export function getModalProvenancesIsOpen(state: IStore): boolean {
  return state.provenances.modal.open
}
